import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "../services/app.service";

@Component({
  selector: "app-location-find",
  templateUrl: "./location-find.component.html",
})
export class LocationFindComponent implements OnInit {
  path = "";
  scheduled: any;
  lat = 0;
  lng = 0;
  distance = 0;
  meterdistance = 0;
  constructor(private router: Router, private appservice: AppService) {}

  ngOnInit() {
    this.getCurrentLocation();

    setTimeout(() => {
      if (!this.lat && !this.lng && !this.scheduled) {
        this.getScheduleDetails();
      }
    }, 6000);
  }

  getScheduleDetails() {
    this.path = this.router.url;
    if (this.path.indexOf("?") > -1) {
      const Splitpath = this.path.split("?");
      const link = Splitpath[1];
      const link1 = link.split("=");

      this.appservice.viewscheduleappointment(link1[1]).subscribe((res) => {
        if (res && res["entity"]) {
          this.scheduled = res["entity"];
          if (
            this.lat &&
            this.lng &&
            this.scheduled.latitude &&
            this.scheduled.longitude
          ) {
            this.distance = Math.round(
              this.calculateDistanceBasedOnselectedLoation(
                this.lat,
                this.lng,
                this.scheduled.latitude,
                this.scheduled.longitude
              )
            );
            if (this.distance > 0) {
              this.meterdistance = Math.round(this.distance * 1000);
              if (this.meterdistance <= 100) {
                this.appservice
                  .updateArrivedStatus(true, this.scheduled.id)
                  .subscribe((res) => ({}));
              }
            } else {
              this.appservice
                .updateArrivedStatus(true, this.scheduled.id)
                .subscribe((res) => ({}));
            }
          }
        }
      });
    }
  }

  getCurrentLocation() {
    if (window.navigator && window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition(
        (showPosition) => {
          this.lat = showPosition.coords.latitude;
          this.lng = showPosition.coords.longitude;
          this.getScheduleDetails();
        },
        (showError) => {
          this.getCurrentIPAddress();
        }
      );
    } else {
      this.getCurrentIPAddress();
    }
  }

  getCurrentIPAddress() {
    this.appservice.getCurrentIPAddress().subscribe(
      (res) => {
        if (res && res["ip"]) {
          this.getAddressBasedonCurrentIp(res["ip"]);
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  getAddressBasedonCurrentIp(ip) {
    this.appservice.getAddressBasedonCurrentIp(ip).subscribe((res) => {
      this.lat = res["lat"];
      this.lng = res["lon"];
      this.getScheduleDetails();
    });
  }

  calculateDistanceBasedOnselectedLoation(
    lat1: number,
    long1: number,
    lat2: number,
    long2: number
  ): number {
    if (lat1 === lat2 && long1 === long2) {
      return 0;
    } else {
      const radlat1 = (Math.PI * lat1) / 180;
      const radlat2 = (Math.PI * lat2) / 180;
      const theta = long1 - long2;
      const radtheta = (Math.PI * theta) / 180;
      let dist =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = (dist * 180) / Math.PI;
      dist = dist * 60 * 1.1515;
      dist = dist * 1.609344;
      return dist;
    }
  }
}
